import vue from 'vue'
import toastComponent from './toast.vue'
import modalComponent from './modal.vue'
import actionSheetComponent from './actionSheet.vue';
import loadingComponent from './loading.vue';

// loading
const LoadingConstructor = vue.extend(loadingComponent)
const loadingDom = new LoadingConstructor({
    el: document.createElement('div'),
    data() {
        return {
            isShow: false, // 是否显示
        }
    }
})
// 添加节点
document.body.appendChild(loadingDom.$el)
function hideLoading() {
    loadingDom.isShow = false
}
function showLoading() {
    loadingDom.isShow = true
}

// actionSheet
const ActionSheetConstructor = vue.extend(actionSheetComponent)
function showActionSheet({ itemList, onHide = () => {} }) {
    const actionSheetDom = new ActionSheetConstructor({
        el: document.createElement('div'),
        data() {
            return {
                isShow: true, // 是否显示
                itemList: itemList, // 文本内容
                onHide: onHide
            }
        }
    })
    // 添加节点
    document.body.appendChild(actionSheetDom.$el)
}

// toast
const ToastConstructor = vue.extend(toastComponent)
function showToast({ text, duration = 2000 }) {
    const toastDom = new ToastConstructor({
        el: document.createElement('div'),
        data() {
            return {
                isShow: true, // 是否显示
                text: text, // 文本内容
            }
        }
    })
    // 添加节点
    document.body.appendChild(toastDom.$el)
    // 过渡时间
    setTimeout(() => {
        toastDom.isShow = false
    }, duration)
}

// modal
const ModalConstructor = vue.extend(modalComponent)
function showModal({ text, showCancel = true, cancelText = '取消', cancelColor = '#323232', confirmText = '确定', confirmColor = '#576B95', onHide = () => {} }) {
    const modalDom = new ModalConstructor({
        el: document.createElement('div'),
        data() {
            return {
                isShow: true,
                text: text,
                showCancel: showCancel,
                cancelText: cancelText,
                cancelColor: cancelColor,
                confirmText: confirmText,
                confirmColor: confirmColor,
                onHide: onHide
            }
        }
    })
    document.body.appendChild(modalDom.$el)
}
// 全局注册
function registryToast() {
    vue.prototype.$showToast = showToast
    vue.prototype.$showModal = showModal
    vue.prototype.$showActionSheet = showActionSheet
    vue.prototype.$showLoading = showLoading
    vue.prototype.$hideLoading = hideLoading
}

export default registryToast